import { ControlPanelMenuItemId } from "../types";

export type StaticControlPanelMenuItem = {
  id: ControlPanelMenuItemId;
  name: string;
  position: number;
  location_template: string;
  icon: string;
  requires_entity: boolean;
  requires_feature_permission: string | null;
  version: string | null;
  subdomain: string;
};

// Static definition of control panel menu items, previously served by the V1 session API.
// Mirrors the backend config: https://github.com/OpenGov/opengov/blob/master/source/ruby/services/delphiusapp/config/control_panel_menu.yml
// Moved client-side as part of the V1 → V3 session migration (V3 no longer returns control_panel_menu_items).

export const CONTROL_PANEL_MENU_ITEMS: readonly StaticControlPanelMenuItem[] = [
  {
    id: "network",
    name: "Network",
    position: 10,
    location_template: "/network/${entity}",
    icon: "network",
    requires_entity: false,
    requires_feature_permission: null,
    version: null,
    subdomain: "controlpanel",
  },
  {
    id: "reports",
    name: "Reports",
    position: 20,
    location_template: "/reports#${entity}",
    icon: "reports",
    requires_entity: true,
    requires_feature_permission: null,
    version: null,
    subdomain: "controlpanel",
  },
  {
    id: "budgets",
    name: "Budgets",
    position: 25,
    location_template: "/budgets/${entity}",
    icon: "budgets",
    requires_entity: true,
    requires_feature_permission: null,
    version: null,
    subdomain: "controlpanel",
  },
  {
    id: "data",
    name: "Data",
    position: 50,
    location_template: "/data_manager/${entity}",
    icon: "data",
    requires_entity: true,
    requires_feature_permission: null,
    version: null,
    subdomain: "controlpanel",
  },
  {
    id: "portal",
    name: "Portal",
    position: 80,
    location_template: "/portal/${entity}/visitor_analytics",
    icon: "portal",
    requires_entity: false,
    requires_feature_permission: null,
    version: null,
    subdomain: "controlpanel",
  },
  {
    id: "initiatives",
    name: "Initiatives",
    position: 82,
    location_template: "/strategic-initiatives/${entity}",
    icon: "initiatives",
    requires_entity: true,
    requires_feature_permission: null,
    version: null,
    subdomain: "controlpanel",
  },
  {
    id: "stories",
    name: "Stories",
    position: 85,
    location_template: "/stories/${entity}",
    icon: "stories",
    requires_entity: true,
    requires_feature_permission: null,
    version: null,
    subdomain: "controlpanel",
  },
  // Surveys (position 87) is omitted — there is no corresponding menu item in the nav bar
  {
    id: "manage",
    name: "Settings",
    position: 90,
    location_template: "/controlpanel#${entity}/manage",
    icon: "manage",
    requires_entity: false,
    requires_feature_permission: null,
    version: null,
    subdomain: "controlpanel",
  },
] as const;
